<template>
  <div class="about">
    <section class="section1 container">
      <!-- <img class="wave-top" src="@/assets/img/wave_top_home.svg" /> -->
      <div class="circle-blue animate-growing"></div>
      <section class="details">
        <!-- <h1 class="main-title">I've got a feeling</h1> -->
        <img
          class="upmood-logo"
          src="@/assets/img/upmood_logo.svg"
          alt="ion Sensor & Mood Tracker"
        />
        <p class="description">
          The first live emotion detection wearable and app.
        </p>
        <!-- <button class="button-gradient" @click="togglePreOrder"><img src="@/assets/img/cart_icon.svg" class="icon"> <span>Pre-Order<br>Online</span></button> -->

        <!-- <button
          class="button-gradient"
          @click="$router.push({ name: 'buynow' })"
        >
          <img src="@/assets/img/cart_icon.svg" class="icon" />
          <span>Shop Now</span>

        </button> -->
        <button @click="gotoShop" tag="button" class="button-cyan">
          Shop Now
        </button>
      </section>
      <section class="image-wrapper">
        <img
          src="@/assets/img/home web@2x.png"
          class="effect-move-up first-image"
        />
      </section>
    </section>

    <section class="section2 container">
      <!-- <div class="circle-cyan"></div> -->
      <!-- <div class="circle-green"></div> -->
      <!-- <div class="circle-yellow animate-shrinking"></div> -->
      <section class="image-wrapper">
        <img src="@/assets/img/Yoga girl@2x.png" />
      </section>
      <section class="details">
        <h3 class="description-title">First of its kind emotion tracking</h3>
        <p class="description">
          Upmood is the first-of-its-kind emotion tracking wearable that uses
          your body’s signals and bio-patterns to enhance emotional awareness.
        </p>
        <!-- <p class="description">
          Paired with the app, Upmood pushes the limit of verbal and non-verbal
          communication and combines the sciences of quality emotional
          monitoring with an all-new social networking experience.
        </p> -->
        <router-link to="/HowItWorks" tag="button" class="button-cyan"
          >Our technology</router-link
        >
        <img src="@/assets/img/air@2x.png" class="air" />
      </section>
    </section>

    <section class="section3 container">
      <section class="image-wrapper">
        <img src="@/assets/img/social experience.png" />
      </section>
      <section class="details-wrapper">
        <h3 class="title">All-new social networking experience</h3>
        <p class="details">
          Paired with the app, Upmood pushes the limit of verbal and non-verbal
          communication and combines the sciences of quality emotional
          monitoring with an all-new social networking experience.
        </p>
        <router-link to="/Features" tag="button" class="button-cyan"
          >Explore app</router-link
        >
      </section>
    </section>

    <section class="section7 container">
      <section class="details-wrapper">
        <h3 class="details-title">What You Need for a Balanced Life</h3>
        <div class="description-wrapper">
          <p class="title">Emotional Awareness</p>
          <p class="description">
            Make conscious choices changing lifestyle by understanding emotion
            trends and patterns with Mood Stream.
          </p>
        </div>

        <div class="description-wrapper">
          <p class="title">Mindfulness</p>
          <p class="description">
            Take good control and balance to everyday life. Understand the
            meaning of life and relationships.
          </p>
        </div>

        <div class="description-wrapper">
          <p class="title">Emotional Relationships</p>
          <p class="description">
            Creating support whenever there are negativity and celebration on
            the positive feelings.
          </p>
        </div>
      </section>
      <section class="image-wrapper">
        <img
          src="@/assets/img/phone 2.png"
          class="effect-move-up phone-image"
        />
      </section>
    </section>

    <section class="section8 container">
      <h3 class="title">Featured Products</h3>
      <section class="products-wrapper">
        <div class="product">
          <img
            src="@/assets/img/Group 112.png"
            alt="Upmood Band"
            class="band"
          />
        </div>
        <div class="product">
          <img
            src="@/assets/img/Group 111.png"
            alt="Upmood Watch"
            class="watch"
          />
        </div>
        <div class="product">
          <img
            src="@/assets/img/Group 110.png"
            alt="Upmood Band"
            class="speaker"
          />
        </div>
      </section>
      <button @click="gotoShop" tag="button" class="button-cyan">
        Shop Now
      </button>
    </section>

    <section class="section9 container">
      <iframe
        src="https://www.youtube.com/embed/OJGCseH162k"
        frameborder="0"
        allow="autoplay; encrypted-media"
        allowfullscreen="allowfullscreen"
      ></iframe>
    </section>

    <section class="section10 container">
      <h3 class="title">As seen on</h3>
      <section class="company-wrapper">
        <img
          :src="trendHunterUrl"
          alt="trendHunter"
          @mouseover="trendHunterUrl = require('@/assets/img/1.png')"
          @mouseout="trendHunterUrl = require('@/assets/img/1_1.png')"
        />
        <img
          :src="riseUrl"
          alt="rise"
          @mouseover="riseUrl = require('@/assets/img/2.png')"
          @mouseout="riseUrl = require('@/assets/img/2_2.png')"
        />
        <img
          :src="incUrl"
          alt="inc"
          @mouseover="incUrl = require('@/assets/img/3.png')"
          @mouseout="incUrl = require('@/assets/img/3_3.png')"
        />
        <img
          :src="geekyGadgetsUrl"
          alt="geekyGadgets"
          @mouseover="geekyGadgetsUrl = require('@/assets/img/4.png')"
          @mouseout="geekyGadgetsUrl = require('@/assets/img/4_4.png')"
        />
        <img
          :src="dailyMailUrl"
          alt="dailyMail"
          @mouseover="dailyMailUrl = require('@/assets/img/5.png')"
          @mouseout="dailyMailUrl = require('@/assets/img/5_5.png')"
        />
        <img
          :src="collisionUrl"
          alt="collision"
          @mouseover="collisionUrl = require('@/assets/img/6.png')"
          @mouseout="collisionUrl = require('@/assets/img/6_6.png')"
        />
        <img
          :src="cesUrl"
          alt="ces"
          @mouseover="cesUrl = require('@/assets/img/7.png')"
          @mouseout="cesUrl = require('@/assets/img/8.png')"
        />
      </section>
    </section>

    <section class="section10 container">
      <h3 class="title">Partner</h3>
      <section class="company-wrapper">
        <img
          class="void"
          :src="voidUrl"
          alt="trendHunter"
          @mouseover="voidUrl = require('@/assets/img/9.png')"
          @mouseout="voidUrl = require('@/assets/img/9_9.png')"
        />
      </section>
    </section>

    <section class="section5 container">
      <div class="wrapper">
        <h2 class="section-title">Start your Upmood journey</h2>

        <p class="description">
          Get a glimpse of your emotion with a single beat!
        </p>

        <div class="download-links">
          <a
            href="https://apps.apple.com/ph/app/upmood-mood-tracker/id1460124789"
            target="_blank"
          >
            <img src="@/assets/img/IOS Store.svg" />
          </a>

          <a
            href="https://play.google.com/store/apps/details?id=com.td.upmood"
            target="_blank"
          >
            <img src="@/assets/img/Android Store.svg" />
          </a>
        </div>
      </div>
    </section>
    <section class="section6 container">
      <img
        class="effect-move-up"
        src="@/assets/img/journey phone mockup.png"
        alt="phone-mockup"
      />
    </section>
  </div>
</template>

<script>
import upmoodBand from "@/components/UpmoodBand";

export default {
  data() {
    return {
      active_comment: 0,
      upmoodBandOption: {
        rotate: true,
        rotationX: 0.02,
        rotationY: -0.7,
        rotationZ: -0.1
      },

      trendHunterUrl: require("@/assets/img/1_1.png"),
      riseUrl: require("@/assets/img/2_2.png"),
      incUrl: require("@/assets/img/3_3.png"),
      geekyGadgetsUrl: require("@/assets/img/4_4.png"),
      dailyMailUrl: require("@/assets/img/5_5.png"),
      collisionUrl: require("@/assets/img/6_6.png"),
      cesUrl: require("@/assets/img/8.png"),
      voidUrl: require("@/assets/img/9_9.png")
    };
  },

  components: {
    upmoodBand
  },

  methods: {
    togglePreOrder() {
      this.$store.dispatch("preOrder/togglePreOrder", true);
    },

    changeComments(n) {
      this.active_comment = n;
    },

    slideComments() {
      this.active_comment += 1;
      if (this.active_comment > 2) {
        this.active_comment = 0;
      }
      this.changeComments(this.active_comment);
      setTimeout(this.slideComments, 5000);
    },

    gotoShop() {
      window.open("https://www.upmooddesignlab.com", "_blank");
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.bracelet.load();
    });
  },

  activated() {
    this.$refs.bracelet.animate();
    this.slideComments();
  },

  deactivated() {
    this.$refs.bracelet.stop();
  }
};
</script>

<style lang="scss" scoped>
.about {
  padding-top: 50px;

  @include mobile {
    width: 100%;
  }

  section.container {
    position: relative;
    padding-left: 150px;

    @include mobile {
      padding: 0px;
    }
  }
}

.section1 {
  display: flex;
  flex-direction: row;
  //   height: 500px;
  margin-top: 100px;

  @include mobile {
    flex-direction: column;
    margin-top: 50px;
    // height: 450px;
    text-align: center;
  }

  .wave-top {
    position: absolute;
    height: 140%;
    top: -310px;
    left: 75px;

    @include mobile {
      position: absolute;
      height: 155px;
      top: -165px;
      left: 79px;
      width: 110%;
    }
  }

  .circle-blue {
    position: absolute;
    height: 183px;
    width: 183px;
    top: -170px;
    left: -100px;

    @include mobile {
      height: 85px;
      width: 85px;
      top: -90px;
      left: -50px;
      display: none;
    }
  }

  section {
    // flex: 1;
    padding: 0px;
    display: flex;
    flex-direction: column;

    @include mobile {
      padding: 0;
    }

    &.details {
      width: 295px;
      margin-top: 50px;
      z-index: +1;

      @include mobile {
        width: 100%;
        margin-top: 0;
      }

      .button-cyan {
        width: 135px;
        @include mobile {
          margin: 0px auto 45px;
        }
      }

      .description {
        color: #6b7a80;
        font-size: 21px;
        font-weight: 600;
        line-height: 35px;
        font-family: $Quicksand;

        @include mobile {
          font-size: 20px;
          line-height: 28px;
          margin: 0 auto 60px;
          width: 278px;
        }
      }

      .upmood-logo {
        height: 55px;
        width: 165px;
        margin: 0px auto 32px 0px;

        @include mobile {
          margin: 50px auto;
        }
      }
    }

    &.image-wrapper {
      flex: 1;

      .first-image {
        width: 121%;
        margin: auto;
        z-index: +1;

        @include mobile {
          width: 100%;
        }
      }
    }
  }
}

.section2 {
  display: flex;
  height: 500px;
  margin-top: 180px;
  padding: 0px 50px 0px 0px;
  justify-content: center;

  @include mobile {
    flex-direction: column-reverse;
    justify-content: center;
    height: auto;
    margin-top: 50px;
    padding: 0px;
  }

  section {
    z-index: +1;

    @include mobile {
      align-self: flex-start;
      width: 100%;
    }

    img {
      width: 100%;
      margin: auto;

      @include mobile {
        display: block;
        margin: auto;
        width: 50%;
      }
    }

    &.details {
      margin-left: auto;
      position: relative;
      text-align: center;
      width: 355px;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: +1;

      @include mobile {
        width: 100%;
        margin: 0px auto 262px;
      }

      .section-title {
        text-align: center;
      }

      .description-title {
        color: #362d2d;
        font-size: 21px;
        margin-bottom: 25px;
        @include mobile {
          width: 174px;
        }
      }

      .description {
        font-family: $Quicksand;
        color: #717c80;
        font-size: 17px;
        line-height: 21px;
        @include mobile {
          width: 352px;
          margin-bottom: 25px;
        }
      }

      .air {
        position: absolute;
        right: -500px;
        top: -25px;
        width: 750px;
        z-index: -1;

        @include mobile {
          display: none;
        }
      }
    }

    &.image-wrapper {
      img {
        position: absolute;
        left: -156px;
        top: 0;
        width: 65%;
      }

      @include mobile {
        position: absolute;
        top: 270px;
        left: 175px;
      }
    }
  }
}

.section3 {
  display: flex;
  flex-direction: column;
  margin-top: 200px;

  @include mobile {
    flex-direction: column-reverse;
  }

  .image-wrapper {
    display: flex;
    flex-basis: 100%;
    flex: 1;
    width: 100%;
    margin-bottom: 70px;
    align-items: center;
    position: relative;

    img {
      width: 75%;
      margin: auto;
    }
  }

  .details-wrapper {
    text-align: center;

    @include mobile {
      margin-bottom: 40px;
    }

    h3 {
      font-family: $Quicksand;
      color: #362d2d;
      font-size: 21px;
      margin-bottom: 22px;
    }

    .details {
      font-family: $Lato;
      color: #717c80;
      font-size: 18px;
      width: 700px;
      margin: 0px auto 30px;

      @include mobile {
        width: 285px;
      }
    }
  }
}

.section7 {
  display: flex;
  margin-top: 150px;

  @include mobile {
    flex-direction: column;
  }

  .details-wrapper {
    display: block;

    @include mobile {
      width: 296px;
      margin: auto;
    }

    .details-title {
      font-family: $Quicksand;
      font-size: 21px;
      color: #362d2d;
      margin-bottom: 50px;
      font-weight: 600;
    }

    .description-wrapper {
      width: 430px;
      margin-bottom: 53px;

      @include mobile {
        width: unset;
      }

      .title {
        font-family: $Lato;
        font-size: 21px;
        color: #362d2d;
        font-weight: 600;
      }

      .description {
        font-family: $Quicksand;
        color: #717c80;
        font-size: 17px;
        line-height: 21px;
      }
    }
  }

  .image-wrapper {
    position: relative;

    @include mobile {
      margin-left: 0px;
      justify-content: center;
      display: flex;
    }

    .phone-image {
      position: absolute;
      top: -75px;
      right: -567px;
      height: 579px;

      @include mobile {
        position: unset;
      }
    }
  }
}

.section8 {
  text-align: center;
  margin-top: 150px;

  h3 {
    font-family: $Quicksand;
    font-size: 32px;
    color: #362d2d;
    font-weight: 600;
    margin-bottom: 70px;
  }

  .products-wrapper {
    display: flex;
    width: 100%;
    margin-bottom: 60px;

    @include mobile {
      flex-direction: column;
    }

    .product {
      display: flex;
      flex-direction: column;
      flex-basis: 100%;
      flex: 1;
      margin-right: 150px;

      @include mobile {
        margin: 0px auto 50px;
      }

      &:last-child {
        margin-right: 0px;

        @include mobile {
          margin: 0px auto 50px;
        }
      }

      img {
        height: 265px;
        width: 150px;
        margin: auto;

        &.speaker {
          width: 215px;
        }
      }
    }
  }
}

.section9 {
  width: 100%;
  padding: 0px !important;
  height: 672px;
  margin-bottom: 200px;
  margin-top: 150px;

  @include mobile {
    height: 270px;
  }

  iframe {
    width: 100%;
    height: 100%;
    border-top: 1px solid #707070;
    border-bottom: 1px solid #707070;
  }
}

.section10 {
  text-align: center;
  margin-top: 150px;

  h3 {
    font-family: $Lato;
    color: #cecfd0;
    font-size: 21px;
    margin-bottom: 56px;
  }

  .company-wrapper {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;

    @include mobile {
      flex-direction: column;
    }

    img {
      margin: 15px 35px;

      @include mobile {
        margin: 0px auto 50px;
      }

      &:last-child {
        margin-right: 0px;

        @include mobile {
          margin: 0px auto 50px;
        }
      }

      &.void {
        width: 260px;
        height: 160px;
        margin: auto;
      }
    }
  }
}

.section5 {
  margin-top: 230px;

  @include mobile {
    margin-bottom: 100px;
    margin-top: 50px;
  }

  .circle-light-yellow {
    height: 499px;
    width: 499px;
    position: absolute;
    top: -240px;
    right: -285px;

    @include mobile {
      height: 500px;
      width: 500px;
      top: -990px;
      right: -430px;
    }
  }

  .wrapper {
    width: 530px;
    text-align: center;
    margin: 0 auto;

    @include mobile {
      width: 100%;
      padding: 0 10px;
    }

    .section-title {
      margin-bottom: 20px;
      line-height: 30px;
      color: #362d2d;
    }

    .description {
      color: #6b7a80;
      font-size: 24px;
      margin-bottom: 70px;
      line-height: 26px;

      @include mobile {
        margin-bottom: 40px;
      }
    }

    .download-links {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        margin: 0 20px;
        width: 200px;
        height: auto;
        transition: 0.3s;
        transition: 1s;
        cursor: pointer;

        &:hover {
          transform: scale(1.1);
        }
      }

      @include mobile {
        flex-direction: column;

        img {
          margin: 5px 0;
          width: 150px;
        }
      }
    }
  }
}

.section6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 200px auto;

  .circle-orange {
    height: 375px;
    width: 375px;
    position: absolute;
    top: -215px;
    left: -220px;

    @include mobile {
      height: 200px;
      width: 200px;
      top: -160px;
      left: -130px;
    }
  }

  .circle-light-yellow {
    height: 90px;
    width: 90px;
    position: absolute;
    top: 240px;
    right: 85px;

    @include mobile {
      height: 100px;
      width: 100px;
      top: -90px;
      right: -50px;
    }
  }

  img {
    width: 720px;
    z-index: +1;

    @include mobile {
      width: 110%;
      position: relative;
    }
  }

  .widget-container {
    margin: 100px 0px 0px;
    z-index: +1;
    text-align: center;
    h3 {
      font-family: $Quicksand;
      color: #363c46;
      margin-bottom: 40px;
      font-size: 21px;
    }

    h5 {
      font-family: $Lato;
      color: #363c46;
      margin-bottom: 23px;
      font-weight: 500;
      font-size: 16px;
    }

    button {
      padding: 22px 13px;
      border: 1px solid #fde98b;
      background-color: #fde98b;
      border-radius: 4px;
      color: #363c46;
      font-size: 16px;
      font-weight: 300;
      line-height: 20px;
      text-align: center;
      margin: 0px;
    }

    iframe {
      display: block;
      border: none;
      border-radius: 5px;
      margin: 0px auto 23px;
    }
  }

  .wave-bottom {
    position: absolute;
    top: 320px;
    width: 400%;
    height: 100%;

    @include mobile {
      top: 206px;
      left: -750px;
      width: 2160px;
    }
  }

  .comments {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #fff;
    margin: 130px 0;
    z-index: +1;

    @include mobile {
      margin-top: 50px;
      margin-bottom: 130px;
      font-size: 14px;
      padding: 0 30px;
      text-align: center;
    }

    .comment-group {
      height: 130px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      div {
        width: 100%;
        max-width: 500px;
        text-align: center;
        display: none;

        &.show {
          display: block;
        }
      }
    }

    > * {
      margin: 15px 0;

      @include mobile {
        margin: 10px 0;
      }
    }

    h3 {
      font-family: $Quicksand;
    }

    q {
      font-size: 16px;
      font-family: $Lato;
      display: block;
    }

    .divider {
      width: 137px;
      border-top: 1px solid #fff;
    }

    img {
      width: 93px;
      margin: 25px 0;
    }

    .dots {
      display: flex;
      width: 50px;
      justify-content: space-evenly;

      span {
        display: inline-block;
        height: 10px;
        width: 10px;
        background-color: #fff;
        border-radius: 50%;

        @include mobile {
          height: 8px;
          width: 8px;
        }
      }

      span.active {
        background-color: $color8;
      }
    }
  }
}
</style>
